<!-- <h5 id="dialog-title">Users</h5> -->
<h4 mat-dialog-title style="margin-bottom: 17px;">{{ modalTitle }}</h4>
<ngx-spinner type="ball-scale-multiple" size="medium" [name]="blockLoader"></ngx-spinner>
<div mat-dialog-content>
	<div *ngIf="selectManagerOption" id="search-and-role">
		<input mat-input type="text" [(ngModel)]="searchForManager" placeholder="Search" (keyup)="searchUsersList()" id="search-manager-input">
		<!-- <mat-select [value]="roleSelectionManager" id="role-selection">
			<mat-option *ngFor="let role of orgRolesNames" [value]="role.id" (click)="filterAllUsers(role)">
				{{ role.name }}
			</mat-option>
		</mat-select> -->
	</div>
	<div id="add-user" *ngIf="!selectManagerOption">
		<button mat-button id="add-user-btn" color="primary" (click)="addUser('User')">
			<mat-icon>person_add</mat-icon>
			Add User
		</button>
		<button mat-button id="add-user-btn" color="primary" (click)="selectManager()">
			<mat-icon>person_add</mat-icon>
			Select Manager
		</button>
	</div>

	<div>
		Location: {{ location }}
	</div>

	<div *ngIf="!selectManagerOption" id="managers-list">
		<div *ngIf="managersList.length >= 1; else noManagersFound">
			<h6>Managers at this location</h6>
			<table style="width: 100%" mat-table [dataSource]="managersListSource" class="mat-elevation-z8" *ngIf="managersList.length >= 1; else noManagersFound">
				<ng-container matColumnDef="status">
					<th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
					<td  mat-cell *matCellDef="let element">
						<p style="margin-bottom: 0px;" *ngIf="element.status" class="green-dot">&#x2022;</p>
						<p style="margin-bottom: 0px;" *ngIf="!element.status" class="red-dot">&#x2022;</p>
					</td>
				</ng-container>

				<ng-container matColumnDef="name">
					<th mat-header-cell *matHeaderCellDef> Name </th>
					<td mat-cell *matCellDef="let element"> {{element.name}} </td>
				</ng-container>

				<ng-container matColumnDef="role">
					<th mat-header-cell *matHeaderCellDef mat-sort-header> Role </th>
					<td mat-cell *matCellDef="let element"> {{ element.role }} </td>
				</ng-container>

				<ng-container matColumnDef="email">
					<th mat-header-cell *matHeaderCellDef> UserId </th>
					<td mat-cell *matCellDef="let element">
						<span *ngIf="!element.empCode">
							{{ element.email }}
						</span>

						<span *ngIf="element.empCode">
							{{ element.empCode }}
						</span>
					</td>
				</ng-container>

				<ng-container matColumnDef="edit">
					<th mat-header-cell *matHeaderCellDef mat-sort-header> Edit </th>
					<td mat-cell *matCellDef="let element">
						<button mat-icon-button color="primary" (click)="editUser(element)">
							<mat-icon style="color: #29c96c">create</mat-icon>
						</button>
					</td>
				</ng-container>

				<!-- Remove Column - un-assigns the manager, it does NOT delete the user. -->
				<ng-container matColumnDef="remove">
					<th mat-header-cell *matHeaderCellDef mat-sort-header> Remove </th>
					<td mat-cell *matCellDef="let element; let i = index">
						<button mat-icon-button color="primary" (click)="removeManager(element, i)"
							matTooltip="Remove as manager of this location">
							<mat-icon style="color: #FE8C6E">person_remove</mat-icon>
						</button>
					</td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="mgrsTableColumns"></tr>
				<tr mat-row *matRowDef="let row; columns: mgrsTableColumns;"></tr>
			</table>

			<!-- <mat-paginator [pageSizeOptions]="[100]" showFirstLastButtons></mat-paginator> -->
		</div>

		<ng-template #noManagersFound>
			No Managers at this level.
		</ng-template>
	</div>

	<div *ngIf="(!selectManagerOption && filteredUsers?.length >= 1) || (selectManagerOption && users.length >= 1); else noUsers">
			<div *ngIf="selectManagerOption">
				<button mat-button class="ignite-style-btn" color="primary" (click)="refreshUsers('latest')">Refresh Users</button>
			</div>

			<p style="margin: 24px 0 8px 0;">Users at this location</p>
			<table style="width: 100%" mat-table [dataSource]="usersDetailsDataSource" class="mat-elevation-z8">
				<ng-container matColumnDef="select">
					<th mat-header-cell *matHeaderCellDef mat-sort-header> select </th>
					<td mat-cell *matCellDef="let element">
						<mat-checkbox [checked]="isUserManager(element.id)" (change)="addToManagersList(element)">
					</mat-checkbox>
					</td>
				</ng-container>

				<ng-container matColumnDef="status">
					<th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
					<td mat-cell *matCellDef="let element">
						<p style="margin-bottom: 0px;" *ngIf="element.status" class="green-dot">&#x2022;</p>
						<p style="margin-bottom: 0px;" *ngIf="!element.status" class="red-dot">&#x2022;</p>
					</td>
				</ng-container>

				<ng-container matColumnDef="name">
					<th mat-header-cell *matHeaderCellDef> Name </th>
					<td mat-cell *matCellDef="let element"> {{element.name}} </td>
				</ng-container>

				<ng-container matColumnDef="role">
					<th mat-header-cell *matHeaderCellDef mat-sort-header> Role </th>
					<td mat-cell *matCellDef="let element"> {{ element.role }} </td>
				</ng-container>

				<ng-container matColumnDef="email">
					<th mat-header-cell *matHeaderCellDef> UserId </th>
					<td mat-cell *matCellDef="let element">
						<span *ngIf="!element.empCode">
							{{ element.email }}
						</span>

						<span *ngIf="element.empCode">
							{{ element.empCode }}
						</span>
					</td>
				</ng-container>

				<ng-container matColumnDef="location">
					<th mat-header-cell *matHeaderCellDef mat-sort-header> Location </th>
					<!-- <td mat-cell *matCellDef="let element.level"> {{ element.location ? element.location : "Unavailable" }} </td> -->
					<td mat-cell *matCellDef="let element" class="location-flex emailCol"  style="    border: none;
					padding: 10px 0px;">
						<div *ngFor="let order of element.level">
							<div style="font-weight: 400 !important;
							display: inline-block;
							font-size: 13px;
							color: #4e4e4e;">{{capitalizeFirstWord(order.value)}}/</div>
						</div>
						<div class="showEmail">
							<div *ngFor="let order of element.level">
								<div>{{capitalizeFirstWord(order.value)}}/</div>
							</div>
						</div>
					</td>
				</ng-container>

				<ng-container matColumnDef="edit">
					<th mat-header-cell *matHeaderCellDef mat-sort-header> Edit </th>
					<td mat-cell *matCellDef="let element">
						<button mat-icon-button color="primary" (click)="editUser(element)">
							<mat-icon style="color: #29c96c">create</mat-icon>
						</button>
					</td>
				</ng-container>

				<!-- Delete Column -->
				<ng-container matColumnDef="delete">
					<th mat-header-cell *matHeaderCellDef mat-sort-header> Delete </th>
					<td mat-cell *matCellDef="let element; let i = index">
						<button mat-icon-button color="primary" (click)="deleteUser(element, i)">
							<mat-icon style="color: #FE8C6E">delete</mat-icon>
						</button>
					</td>
				</ng-container>

				<ng-container matColumnDef="phone">
					<th mat-header-cell *matHeaderCellDef> Phone Number </th>
					<td mat-cell *matCellDef="let element"> {{element.phone}} </td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="displayedTableColumns"></tr>
				<tr mat-row *matRowDef="let row; columns: displayedTableColumns;"></tr>
			</table>

			<div class="nextPrevBtn" *ngIf="searchForManager.length <= 2 && selectManagerOption">
				<button class="prevBtn" (click)="previousUsers()" [disabled]="!hasPreviousUsers">Previous</button>
				<button class="nextBtn" (click)="nextUsers()" [disabled]="!hasMoreUsers">Next</button>
			</div>

			<!-- <mat-paginator [pageSizeOptions]="[100]" showFirstLastButtons></mat-paginator> -->
		<!-- </div> -->
	</div>

	<ng-template #noUsers>
		<h6 id="no-users-header">No users found.</h6>
	</ng-template>
</div>

<button *ngIf="!selectManagerOption" mat-raised-button (click)="closeDialog()" id="close-dialog-btn">CLOSE</button>
<button style="margin-right: 10px;" *ngIf="selectManagerOption" mat-raised-button (click)="cancel()" id="close-dialog-btn">CLOSE</button>
<button *ngIf="selectManagerOption" mat-raised-button (click)="confirmManager()" id="close-dialog-btn">CONFIRM</button>